import AccountSettings from "./components/AccountSettings";
import WidgetAppDisplayOrder from "./components/widgetAppDisplayOrder";

const Settings = (props: any) => {
  return (
    <>
      <div className="row settings-mobile">
        <div className="col-lg-12">
          <AccountSettings />
        </div>
        <WidgetAppDisplayOrder />
      </div>
    </>
  );
};

export default Settings;
